module.exports = __webpack_public_path__ + "static/media/GeneralDynamics.b9df49d3.png";